<template>
	<div>
		<!-- 表头 -->
		<div class="table-th" ref="table_th"  :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px'}">
					{{item.title}}
					
				</div>
				
			</div>
		</div>
		
		<!-- 总计 -->
		<div v-if="Object.keys(tableTotalData).length > 0" >
			<div class="table-td" :style="{'width': table_scroll_width + 'px'}">
					<div v-for="(item,index) in tableTotalData" :key="index" class="table-td-cell"
					:style="{'width':item.widths + 'px'}">
						{{index === 0?'总计':item.value}}
					</div>
					
			</div>
			<!-- <div class="table-td-cell">
				{{tableTotalData.used_money}}
			</div> -->
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div v-for="(item_z,index_z) in item" :key="index_z" class="table-td-cell" :style="{'width':item_z.widths + 'px'}">
				
					{{item_z.value}}
				
			</div>
			<div  class="table-td-cell" style="width:180px;">
				<a-button @click="editButton(index)" style="background-color: #e6a23c;border-color: #e6a23c;margin-right: 10px;" size='small' type="primary">编辑</a-button>
				<a-button @click="delButton(index)" type="danger" size='small'>删除</a-button>
			</div>
			
		</div>
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
</template>

<script>
export default {
	name: 'TableAssistant',
	props: ['rableTitle','tableShowData','tableTotalData','table_scroll_width'],
	data(){
		return {
			
			
		}
	},
	methods: {
		// 编辑
		editButton(index){
			// console.log(this.tableShowData[index])
			this.$emit('editDrawerButton',index)
		},
		// 删除
		delButton(index){
			this.$emit('delDrawerButton',index)
		}
	},
}
</script>

<style scoped>

/* .table-th-cell:hover {
	background-color: #eee;
} */
	
</style>